import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { Credentials } from "@/components/sections/Credentials";
import { Process } from "@/components/sections/Process";
import { Testimonials } from "@/components/sections/Testimonials";
import { FinalCta } from "@/components/sections/FinalCta";
import { LeadForm } from "@/components/sections/LeadForm";

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <Seo path="/about" title="About Solar Energy Doc LLC | Licensed & Certified Texas Solar Company"
        description="Solar Energy Doc LLC is a licensed and insured Texas solar and electrical company — Tesla, Enphase and SolarEdge certified — serving homeowners and businesses statewide." />
      <PageHero eyebrow="About Solar Energy Doc" testId="about-page-hero" lines={["We understand the", "technology behind it."]}
        sub="Solar Energy Doc LLC is a licensed and insured Texas solar company. We install, maintain, troubleshoot and support solar, battery and electrical systems for homeowners and businesses across the state." />
      <WhyChoose />
      <Credentials />
      <Process />
      <Testimonials />
      <FinalCta />
      <LeadForm />
    </main>
  );
}
